import React, { useCallback, useState } from 'react';
import { AddressDoorbellPosition } from '../../../../components/AddressDoorbellPosition/AddressDoorbellPosition';
import { Button } from '../../../../components/Button/Button';
import { LatLng } from '../../../../components/Map/Map';
import { AddressParts } from '../../../../hooks/useDesktopGoogleApi';
import { useLanguage } from '../../../../locale/useLanguage';

import './DeliveryPoint.css';

type DeliveryPointProps = {
  address: AddressParts;
  doorbellLat?: number;
  doorbellLng?: number;
  onSaveAndClose: (latLng: LatLng) => void;
  onAddNotes: (latLng: LatLng) => void;
};

export const DeliveryPoint: React.FC<DeliveryPointProps> = ({
  address,
  doorbellLat,
  doorbellLng,
  onAddNotes,
  onSaveAndClose,
}) => {
  const [t] = useLanguage();
  const {
    aal2,
    aal3,
    streetNumber,
    street,
    zipCode,
    lat: addressLat,
    lng: addressLng,
  } = address;

  const [lat, setLat] = useState(doorbellLat || addressLat);
  const [lng, setLng] = useState(doorbellLng || addressLng);

  const onMapClick = useCallback(({ lat, lng }: LatLng) => {
    setLat(lat);
    setLng(lng);
  }, []);

  const saveAndClose = useCallback(() => {
    onSaveAndClose({ lat, lng });
  }, [lat, lng, onSaveAndClose]);

  const addNotes = useCallback(() => {
    onAddNotes({ lat, lng });
  }, [lat, lng, onAddNotes]);

  return (
    <>
      <AddressDoorbellPosition
        address={`${street}, ${streetNumber}, ${aal3}, ${aal2}, ${zipCode}`}
        lat={lat}
        lng={lng}
        onMapClick={onMapClick}
      />
      <Button
        label={t('selectDeliveryPointView.addNotes')}
        onClick={addNotes}
        isPrimary
      />
      <div className="delivery-point--save-button">
        <Button
          label={t('selectDeliveryPointView.saveAndClose')}
          onClick={saveAndClose}
        />
      </div>
    </>
  );
};
